import styled from 'styled-components';
import { devices } from '../../../styles/viewports';

export const StatusBannerWrapper = styled.div`
  padding: 26px 150px;
  display: flex;
  justify-content: space-between;
  background-color: var(--base-color-lightgrey);
  transition: transform 0.3s ease;
  transform-origin: top;

  @media ${devices.mobile} {
    padding: 20px 20px;
  }

  @media ${devices.tablet} {
    padding: 20px 50px;
  }

  &.closing {
    transform: scaleY(0);
  }
`;

export const ContentContainer = styled.div`
  overflow: auto;
  transition: max-height 0.3s ease-in-out;
  font-size: var(--font-size-body-1);
  font-family: var(--font-family-body);
  font-feature-settings: var(--font-feature-settings-body);
  font-weight: var(--font-weight-body-1);
  letter-spacing: var(--letter-spacing-body-1);
  line-height: var(--line-height-body-1);
`;

export const SvgContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: end;

  svg {
    width: var(--navigation-large-gap);
    height: var(--navigation-large-gap);
    padding-left: 50px;
  }

  cursor: pointer;

  @media ${devices.mobile} {
    padding-left: 20px;
  }
`;
